import { history } from '../AppContext'

type SessionTimeoutHandler = () => Promise<void>;
let sessionTimeoutHandler: SessionTimeoutHandler | undefined;

/**
 * Register a handler to be invoked when a 401 session-timeout error is detected.
 * This avoids a direct import of Authentication here, which would create a circular
 * dependency: Authentication → ApiClient → BaseClient → UserSession → Authentication.
 */
export function registerSessionTimeoutHandler(handler: SessionTimeoutHandler): void {
    sessionTimeoutHandler = handler;
}

export const checkErrorForSessionTimeout = (error: any) => {
    if (error && error.status === 401) {
        if (sessionTimeoutHandler) {
            sessionTimeoutHandler()
                .then(() => history.push('/'))
                .catch(() => { });
        } else {
            history.push('/');
        }
    }
}

